export default __webpack_public_path__ + "static/media/React-icon.20adfb35.png";